import { loanApi } from "@api/loans";
import { patronApi } from "@api/patrons";
import { invenioConfig } from "@config";

/**
 * Check if a patron has reached their borrowing limit
 * @param {string} patronPid - The patron's PID
 * @param {number} itemsInCurrentTransaction - Number of items being borrowed in this transaction
 * @returns {Promise<Object>} - Object containing limit info: { limit, current, canBorrow }
 */
export const checkBorrowingLimit = async (patronPid) => {
  try {
    // Get the patron to determine their type
    const patronResponse = await patronApi.get(patronPid);
    const patron = patronResponse.data;
    const patronType = patron.metadata?.patron_type || "_default";

    // Get the configured borrowing limit based on patron type
    const limitConfig = invenioConfig.CIRCULATION.borrowingLimits || {};
    const borrowingLimit = limitConfig[patronType] || limitConfig._default || 5;

    // Make sure we always have a reasonable minimum limit
    if (borrowingLimit <= 0) {
      console.warn("Invalid borrowing limit detected:", borrowingLimit);
      return { limit: 5, current: 0, canBorrow: true };
    }

    // Count active loans for this patron
    const query = loanApi
      .query()
      .withPatronPid(patronPid)
      .withState(invenioConfig.CIRCULATION.loanActiveStates)
      .qs();
    const loansResponse = await loanApi.list(query);
    const currentlyBorrowed = loansResponse.data.total;

    // Check if the patron can borrow more items
    const canBorrow = currentlyBorrowed < borrowingLimit;

    return {
      limit: borrowingLimit,
      current: currentlyBorrowed,
      canBorrow: canBorrow,
    };
  } catch (error) {
    // Default to allowing checkout in case of errors
    return { limit: 5, current: 0, canBorrow: true };
  }
};
